import styled from "styled-components";
const ConfigSummaryDefinitionListWrapper = styled.div`
  dl {
    margin-top: 10px;

    dt {
      float: left;
      clear: left;
    }

    dd {
      margin-left: 185px;
      overflow-wrap: break-word;

      &:not(:last-child) {
        border-bottom: 1px solid #ececec;
        margin-bottom: 5px;
        padding-bottom: 5px;
      }
    }
  }
`;
export default ConfigSummaryDefinitionListWrapper;
